import { ASSET_NAME } from '../LandingPage/LandingPage.duck';

// ================ Action types ================ //
export const QUERY_LANDSCAPES_SECTION_REQUEST =
  'app/TopbarContainer/QUERY_LANDSCAPES_SECTION_REQUEST';
export const QUERY_LANDSCAPES_SECTION_SUCCESS =
  'app/TopbarContainer/QUERY_LANDSCAPES_SECTION_SUCCESS';
export const QUERY_LANDSCAPES_SECTION_ERROR = 'app/TopbarContainer/QUERY_LANDSCAPES_SECTION_ERROR';

// ================ Reducer ================ //

const initialState = {
  rewildingLandscapesSection: {},
  rewildingLandscapesSectionError: null,
};

export default function topbarContainerReducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case QUERY_LANDSCAPES_SECTION_REQUEST:
      return { ...state, rewildingLandscapesSectionError: null };
    case QUERY_LANDSCAPES_SECTION_SUCCESS:
      return { ...state, rewildingLandscapesSection: payload };
    case QUERY_LANDSCAPES_SECTION_ERROR:
      return { ...state, rewildingLandscapesSectionError: payload };
    default:
      return state;
  }
}

// ================ Action creators ================ //

export const queryLandscapesSectionRequest = () => ({
  type: QUERY_LANDSCAPES_SECTION_REQUEST,
});

export const queryLandscapesSectionSuccess = payload => ({
  type: QUERY_LANDSCAPES_SECTION_SUCCESS,
  payload,
});

export const queryLandscapesSectionError = e => ({
  type: QUERY_LANDSCAPES_SECTION_ERROR,
  error: true,
  payload: e,
});

// ================ Thunks ================ //

export const getLandscapesSection = () => (dispatch, getState, sdk) => {
  dispatch(queryLandscapesSectionRequest());

  try {
    sdk.assetByAlias({ path: `content/pages/${ASSET_NAME}.json`, alias: 'latest' }).then(res => {
      const { sections } = res.data.data;
        const rewildingLandscapesSection = sections
          ? sections.find(item => item.sectionId === 'rewilding-landscapes')
          : {};
        dispatch(queryLandscapesSectionSuccess(rewildingLandscapesSection));
      });
  } catch (e) {
    dispatch(queryLandscapesSectionError(e));
  }
};
